module.exports = __webpack_public_path__ + "img/icon_sheet_1.db0e4ec5.svg";